import {Map} from 'immutable';
import {REDUCE_SET_CALL_INSTANCE, REDUCE_SET_CALLING_STATUS, REDUCE_SET_CALL_SYSTEM_STATUS,REDUCE_SET_CALL_INIT_STATUS,REDUCE_SET_CALL_PLATFORM_STATUS,REDUCE_SET_CALLING_ID, REDUCE_SET_WARNING} from '../types';
import {EnumCallingStatus, EnumCallSystemStatus} from '../../types/gdcall';

const initState = Map({
    callInstance: null,
    callingStatus:EnumCallingStatus.onLine,
    callSystemStatus:EnumCallSystemStatus.notLogin,
    callInitStatus:undefined,
    callPlatformStatus:undefined,
    callingId:undefined
});
export default function gdCallReduxState(state = initState, {type, data}: any) {
    switch (type) {
    case REDUCE_SET_CALL_INSTANCE:
        return state.set('callInstance', data);
    case REDUCE_SET_CALLING_STATUS:
        return state.set('callingStatus', data);
    case REDUCE_SET_CALL_SYSTEM_STATUS:
        return state.set('callSystemStatus', data);
    case REDUCE_SET_CALL_INIT_STATUS:
        return state.set('callInitStatus', data);
    case REDUCE_SET_CALL_PLATFORM_STATUS:
        return state.set('callPlatformStatus', data);
    case REDUCE_SET_CALLING_ID:
        return state.set('callingId', data);
    case REDUCE_SET_WARNING:
        return state.set('callWarningInfo', data);
    default:
        return state;
    }
}